export default class Footer {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
  }
}
